export enum StorePermissionEnum {
  SaleView = 'sale:view',
  SaleCreate = 'sale:create',
  SaleEdit = 'sale:edit',
  SaleCancel = 'sale:cancel',
  SaleReturn = 'sale:return',
}
